const validPostalCodes = [
'40000',
'40009',
'40010',
'40020',
'40030',
'40040',
'40050',
'40060',
'40070',
'40080',
'40090',
'40100',
'40110',
'40120',
'40130',
'40140',
'40150',
'40160',
'40170',
'40180',
'40190',
'40200',
'40210',
'40220',
'40230',
'40240',
'40250',
'40260',
'40270',
'40280',
'40290',
'40300',
'40350',
'40360',
'40400',
'40410',
'40420',
'40430',
'40440',
'40450',
'40460',
'40470',
'40475',
'40480',
'40490',
'40500',
'40501',
'40502',
'40503',
'40504',
'40505',
'40506',
'40507',
'40508',
'40509',
'40510',
'40511',
'40512',
'40513',
'40514',
'40515',
'40516',
'40517',
'40518',
'40519',
'40520',
'40521',
'40522',
'40523',
'40524',
'40525',
'40526',
'40527',
'40528',
'40529',
'40530',
'40531',
'40532',
'40533',
'40534',
'40535',
'40536',
'40537',
'40538',
'40539',
'40540',
'40541',
'40542',
'40543',
'40544',
'40545',
'40546',
'40547',
'40548',
'40549',
'40550',
'40551',
'40552',
'40553',
'40554',
'40555',
'40556',
'40557',
'40558',
'40559',
'40560',
'40561',
'40562',
'40563',
'40564',
'40565',
'40566',
'40567',
'40568',
'40569',
'40570',
'40571',
'40572',
'40573',
'40574',
'40575',
'40576',
'40577',
'40578',
'40579',
'40580',
'40581',
'40582',
'40583',
'40584',
'40585',
'40586',
'40587',
'40588',
'40589',
'40590',
'40591',
'40592',
'40593',
'40594',
'40595',
'40596',
'40597',
'40598',
'40599',
'40600',
'40601',
'40602',
'40603',
'40604',
'40605',
'40606',
'40607',
'40608',
'40609',
'40610',
'40611',
'40612',
'40613',
'40614',
'40615',
'40616',
'40617',
'40618',
'40619',
'40620',
'40621',
'40622',
'40623',
'40624',
'40625',
'40626',
'40627',
'40628',
'40629',
'40630',
'40631',
'40632',
'40633',
'40634',
'40635',
'40636',
'40637',
'40638',
'40639',
'40640',
'40641',
'40642',
'40643',
'40644',
'40645',
'40646',
'40647',
'40648',
'40649',
'40650',
'40660',
'40661',
'40662',
'40663',
'40664',
'40665',
'40666',
'40667',
'40668',
'40669',
'40670',
'40671',
'40672',
'40673',
'40674',
'40675',
'40676',
'40677',
'40678',
'40679',
'40680',
'40681',
'40682',
'40683',
'40684',
'40685',
'40686',
'40687',
'40688',
'40689',
'40690',
'40700',
'40701',
'40702',
'40703',
'40704',
'40705',
'40706',
'40707',
'40708',
'40709',
'40710',
'40711',
'40712',
'40713',
'40714',
'40715',
'40716',
'40717',
'40718',
'40719',
'40720',
'40721',
'40722',
'40723',
'40724',
'40725',
'40726',
'40727',
'40728',
'40729',
'40730',
'40731',
'40732',
'40733',
'40734',
'40735',
'40736',
'40737',
'40738',
'40739',
'40740',
'40750',
'40760',
'40770',
'40780',
'40790',
'40800',
'40801',
'40802',
'40803',
'40804',
'40805',
'40806',
'40807',
'40808',
'40810',
'40820',
'40830',
'40840',
'40850',
'40860',
'40870',
'40880',
'40890',
'40900',
'40990',
'41000',
'41001',
'41002',
'41003',
'41004',
'41005',
'41006',
'41007',
'41008',
'41009',
'41010',
'41020',
'41030',
'41040',
'41050',
'41060',
'41070',
'41080',
'41090',
'41100',
'41110',
'41120',
'41130',
'41140',
'41150',
'41160',
'41170',
'41180',
'41190',
'41200',
'41210',
'41220',
'41230',
'41240',
'41250',
'41260',
'41270',
'41280',
'41290',
'41300',
'41310',
'41320',
'41330',
'41340',
'41350',
'41360',
'41370',
'41380',
'41390',
'41400',
'41410',
'41420',
'41430',
'41440',
'41450',
'41460',
'41470',
'41480',
'41490',
'43200',
'43207',
'43210',
'43220',
'43230',
'43240',
'43250',
'43260',
'43270',
'43280',
'43290',
'43299',
'46000',
'46010',
'46020',
'46030',
'46040',
'46050',
'46060',
'46070',
'46080',
'46090',
'46100',
'46110',
'46120',
'46130',
'46140',
'46150',
'46160',
'46170',
'46180',
'46190',
'46200',
'46210',
'46220',
'46230',
'46240',
'46250',
'46260',
'46270',
'46280',
'46290',
'46300',
'46310',
'46320',
'46330',
'46340',
'46350',
'46360',
'46370',
'46380',
'46390',
'46400',
'46410',
'46420',
'46430',
'46440',
'46450',
'46460',
'46470',
'46480',
'46490',
'46500',
'46501',
'46502',
'46503',
'46504',
'46505',
'46506',
'46507',
'46508',
'46509',
'46510',
'46520',
'46530',
'46540',
'46547',
'46549',
'46550',
'46551',
'46560',
'46564',
'46570',
'46580',
'46582',
'46590',
'46598',
'46600',
'46610',
'46620',
'46630',
'46640',
'46650',
'46660',
'46662',
'46667',
'46668',
'46670',
'46672',
'46675',
'46680',
'46690',
'46700',
'46710',
'46720',
'46730',
'46740',
'46750',
'46760',
'46770',
'46780',
'46781',
'46782',
'46783',
'46784',
'46785',
'46786',
'46787',
'46788',
'46789',
'46790',
'46791',
'46792',
'46793',
'46794',
'46795',
'46796',
'46797',
'46798',
'46799',
'46800',
'46801',
'46802',
'46803',
'46804',
'46805',
'46806',
'46807',
'46808',
'46809',
'46810',
'46820',
'46830',
'46840',
'46850',
'46860',
'46870',
'46880',
'46890',
'46900',
'46910',
'46920',
'46930',
'46940',
'46950',
'46960',
'46961',
'46962',
'46963',
'46964',
'46965',
'46966',
'46967',
'46968',
'46969',
'46970',
'46971',
'46972',
'46973',
'46974',
'46975',
'46976',
'46977',
'46978',
'46979',
'46980',
'46990',
'47000',
'47100',
'47110',
'47120',
'47130',
'47140',
'47150',
'47160',
'47170',
'47180',
'47190',
'47200',
'47210',
'47220',
'47230',
'47240',
'47250',
'47260',
'47270',
'47280',
'47290',
'47300',
'47301',
'47302',
'47303',
'47304',
'47305',
'47306',
'47307',
'47308',
'47309',
'47400',
'47410',
'47420',
'47430',
'47440',
'47450',
'47460',
'47470',
'47480',
'47490',
'47500',
'47501',
'47502',
'47503',
'47504',
'47505',
'47506',
'47507',
'47508',
'47509',
'47510',
'47520',
'47530',
'47540',
'47550',
'47560',
'47570',
'47580',
'47590',
'47600',
'47610',
'47620',
'47630',
'47640',
'47650',
'47660',
'47670',
'47680',
'47690',
'47800',
'47810',
'47820',
'47830',
'47840',
'47850',
'47860',
'47870',
'47880',
'47890',
'50000',
'50010',
'50020',
'50030',
'50040',
'50050',
'50060',
'50070',
'50080',
'50081',
'50082',
'50083',
'50084',
'50085',
'50086',
'50087',
'50088',
'50089',
'50090',
'50100',
'50110',
'50120',
'50130',
'50140',
'50150',
'50160',
'50170',
'50180',
'50190',
'50200',
'50210',
'50220',
'50230',
'50240',
'50250',
'50260',
'50270',
'50280',
'50290',
'50300',
'50310',
'50320',
'50330',
'50350',
'50360',
'50370',
'50380',
'50390',
'50400',
'50410',
'50420',
'50430',
'50440',
'50450',
'50460',
'50470',
'50480',
'50490',
'50500',
'50501',
'50502',
'50503',
'50504',
'50505',
'50506',
'50507',
'50508',
'50510',
'50511',
'50512',
'50513',
'50514',
'50515',
'50517',
'50519',
'50520',
'50521',
'50522',
'50523',
'50528',
'50529',
'50530',
'50532',
'50534',
'50535',
'50536',
'50538',
'50540',
'50544',
'50546',
'50548',
'50550',
'50551',
'50552',
'50554',
'50556',
'50560',
'50562',
'50564',
'50566',
'50568',
'50572',
'50576',
'50578',
'50580',
'50582',
'50586',
'50587',
'50588',
'50590',
'50592',
'50594',
'50596',
'50598',
'50599',
'50600',
'50603',
'50604',
'50605',
'50608',
'50609',
'50610',
'50612',
'50614',
'50615',
'50620',
'50621',
'50622',
'50623',
'50624',
'50625',
'50626',
'50628',
'50630',
'50632',
'50634',
'50636',
'50638',
'50640',
'50642',
'50644',
'50646',
'50648',
'50650',
'50652',
'50653',
'50656',
'50658',
'50660',
'50661',
'50662',
'50664',
'50666',
'50668',
'50670',
'50672',
'50673',
'50676',
'50677',
'50678',
'50680',
'50681',
'50682',
'50683',
'50684',
'50685',
'50686',
'50687',
'50688',
'50689',
'50690',
'50691',
'50692',
'50693',
'50694',
'50695',
'50696',
'50697',
'50698',
'50699',
'50700',
'50701',
'50702',
'50703',
'50704',
'50705',
'50706',
'50707',
'50708',
'50709',
'50710',
'50711',
'50712',
'50713',
'50714',
'50715',
'50716',
'50717',
'50718',
'50719',
'50720',
'50721',
'50722',
'50723',
'50724',
'50725',
'50726',
'50727',
'50728',
'50729',
'50730',
'50731',
'50732',
'50733',
'50734',
'50735',
'50736',
'50737',
'50738',
'50739',
'50740',
'50741',
'50742',
'50743',
'50744',
'50745',
'50746',
'50747',
'50748',
'50749',
'50750',
'50751',
'50752',
'50753',
'50754',
'50755',
'50756',
'50757',
'50758',
'50759',
'50760',
'50761',
'50762',
'50763',
'50764',
'50765',
'50766',
'50767',
'50768',
'50769',
'50770',
'50771',
'50772',
'50773',
'50774',
'50775',
'50776',
'50777',
'50778',
'50779',
'50780',
'50781',
'50782',
'50783',
'50784',
'50785',
'50786',
'50787',
'50788',
'50789',
'50790',
'50791',
'50792',
'50793',
'50794',
'50795',
'50796',
'50797',
'50798',
'50799',
'50800',
'50801',
'50802',
'50803',
'50804',
'50805',
'50806',
'50807',
'50808',
'50809',
'50810',
'50811',
'50812',
'50813',
'50814',
'50815',
'50816',
'50817',
'50818',
'50819',
'50820',
'50821',
'50822',
'50823',
'50824',
'50825',
'50826',
'50827',
'50828',
'50829',
'50830',
'50831',
'50832',
'50833',
'50834',
'50835',
'50836',
'50837',
'50838',
'50839',
'50840',
'50841',
'50842',
'50843',
'50844',
'50845',
'50846',
'50847',
'50848',
'50849',
'50850',
'50851',
'50852',
'50853',
'50854',
'50855',
'50856',
'50857',
'50858',
'50859',
'50860',
'50861',
'50862',
'50863',
'50864',
'50865',
'50866',
'50867',
'50868',
'50869',
'50870',
'50871',
'50872',
'50873',
'50874',
'50875',
'50876',
'50877',
'50878',
'50879',
'50880',
'50881',
'50882',
'50883',
'50884',
'50885',
'50886',
'50887',
'50888',
'50889',
'50890',
'50891',
'50892',
'50893',
'50894',
'50895',
'50896',
'50897',
'50898',
'50899',
'50900',
'50901',
'50902',
'50903',
'50904',
'50906',
'50907',
'50908',
'50909',
'50910',
'50911',
'50912',
'50913',
'50914',
'50915',
'50916',
'50917',
'50918',
'50919',
'50920',
'50921',
'50922',
'50923',
'50924',
'50925',
'50926',
'50927',
'50928',
'50929',
'50930',
'50931',
'50932',
'50933',
'50934',
'50935',
'50936',
'50937',
'50938',
'50939',
'50940',
'50941',
'50942',
'50943',
'50944',
'50945',
'50946',
'50947',
'50948',
'50949',
'50950',
'50951',
'50952',
'50953',
'50954',
'50955',
'50956',
'50957',
'50958',
'50959',
'50960',
'50961',
'50962',
'50963',
'50964',
'50965',
'50966',
'50967',
'50968',
'50969',
'50970',
'50971',
'50972',
'50973',
'50974',
'50975',
'50976',
'50977',
'50978',
'50979',
'50980',
'50981',
'50982',
'50983',
'50984',
'50985',
'50986',
'50987',
'50988',
'50989',
'50990',
'50991',
'50992',
'50993',
'50994',
'50995',
'50996',
'50997',
'50998',
'50999',
'51000',
'51010',
'51020',
'51030',
'51040',
'51050',
'51060',
'51070',
'51080',
'51090',
'51100',
'51110',
'51120',
'51130',
'51140',
'51150',
'51160',
'51170',
'51180',
'51190',
'51200',
'51210',
'51220',
'51230',
'51240',
'51250',
'51260',
'51270',
'51280',
'51290',
'51300',
'51310',
'51320',
'51330',
'51340',
'51350',
'51360',
'51370',
'51380',
'51390',
'51400',
'51410',
'51420',
'51430',
'51440',
'51450',
'51460',
'51470',
'51480',
'51490',
'51500',
'51510',
'51520',
'51530',
'51540',
'51550',
'51560',
'51570',
'51580',
'51590',
'51600',
'51610',
'51620',
'51630',
'51640',
'51650',
'51660',
'51670',
'51680',
'51690',
'51700',
'51710',
'51720',
'51730',
'51740',
'51750',
'51760',
'51770',
'51780',
'51790',
'51800',
'51810',
'51820',
'51830',
'51840',
'51850',
'51860',
'51870',
'51880',
'51890',
'51900',
'51910',
'51920',
'51930',
'51940',
'51950',
'51960',
'51970',
'51980',
'51990',
'52000',
'52010',
'52020',
'52030',
'52040',
'52050',
'52060',
'52070',
'52080',
'52090',
'52100',
'52109',
'52110',
'52120',
'52130',
'52140',
'52150',
'52160',
'52170',
'52180',
'52190',
'52200',
'52210',
'52220',
'52230',
'52240',
'52250',
'52260',
'52270',
'52280',
'52290',
'52300',
'52310',
'52320',
'52330',
'52340',
'52350',
'52360',
'52370',
'52380',
'52390',
'52400',
'52410',
'52420',
'52430',
'52440',
'52450',
'52460',
'52470',
'52480',
'52490',
'52500',
'52510',
'52520',
'52530',
'52540',
'52550',
'52560',
'52570',
'52580',
'52590',
'52600',
'52610',
'52620',
'52630',
'52640',
'52650',
'52660',
'52670',
'52680',
'52690',
'52700',
'52710',
'52720',
'52730',
'52740',
'52750',
'52760',
'52770',
'52780',
'52790',
'52800',
'52810',
'52820',
'52830',
'52840',
'52850',
'52860',
'52870',
'52880',
'52890',
'52900',
'52910',
'52920',
'52930',
'52940',
'52950',
'52960',
'52970',
'52980',
'52990',
'53000',
'53010',
'53020',
'53030',
'53040',
'53050',
'53060',
'53070',
'53080',
'53090',
'53100',
'53110',
'53120',
'53130',
'53140',
'53150',
'53160',
'53170',
'53180',
'53190',
'53200',
'53210',
'53220',
'53230',
'53240',
'53250',
'53260',
'53270',
'53280',
'53290',
'53300',
'53310',
'53320',
'53330',
'53340',
'53350',
'53360',
'53370',
'53380',
'53390',
'53400',
'53410',
'53420',
'53430',
'53440',
'53450',
'53460',
'53470',
'53480',
'53490',
'53500',
'53510',
'53520',
'53530',
'53540',
'53550',
'53560',
'53570',
'53580',
'53590',
'53600',
'53610',
'53620',
'53630',
'53640',
'53650',
'53660',
'53670',
'53680',
'53690',
'53700',
'53710',
'53720',
'53730',
'53740',
'53750',
'53760',
'53770',
'53780',
'53790',
'53800',
'53810',
'53820',
'53830',
'53840',
'53850',
'53860',
'53870',
'53880',
'53890',
'53900',
'53910',
'53920',
'53930',
'53940',
'53950',
'53960',
'53970',
'53980',
'53990',
'54000',
'54010',
'54020',
'54030',
'54040',
'54050',
'54060',
'54070',
'54080',
'54090',
'54100',
'54110',
'54120',
'54130',
'54140',
'54150',
'54160',
'54170',
'54180',
'54190',
'54200',
'54210',
'54220',
'54230',
'54240',
'54250',
'54260',
'54270',
'54280',
'54290',
'54300',
'54310',
'54320',
'54330',
'54340',
'54350',
'54360',
'54370',
'54380',
'54390',
'54400',
'54410',
'54420',
'54430',
'54440',
'54450',
'54460',
'54470',
'54480',
'54490',
'54500',
'54510',
'54520',
'54530',
'54540',
'54550',
'54560',
'54570',
'54580',
'54590',
'54600',
'54610',
'54620',
'54630',
'54640',
'54650',
'54660',
'54670',
'54680',
'54690',
'54700',
'54710',
'54720',
'54730',
'54740',
'54750',
'54760',
'54770',
'54780',
'54790',
'54800',
'54810',
'54820',
'54830',
'54840',
'54850',
'54860',
'54870',
'54880',
'54890',
'54900',
'54910',
'54920',
'54930',
'54940',
'54950',
'54960',
'54970',
'54980',
'54990',
'55000',
'55010',
'55020',
'55030',
'55040',
'55050',
'55060',
'55070',
'55080',
'55090',
'55100',
'55110',
'55120',
'55130',
'55140',
'55150',
'55160',
'55170',
'55180',
'55188',
'55190',
'55200',
'55210',
'55220',
'55230',
'55240',
'55250',
'55260',
'55270',
'55280',
'55290',
'55300',
'55310',
'55320',
'55330',
'55340',
'55350',
'55360',
'55370',
'55380',
'55390',
'55400',
'55410',
'55420',
'55430',
'55440',
'55450',
'55460',
'55470',
'55480',
'55490',
'55500',
'55510',
'55520',
'55530',
'55540',
'55550',
'55560',
'55570',
'55580',
'55590',
'55600',
'55610',
'55620',
'55630',
'55640',
'55650',
'55660',
'55670',
'55680',
'55690',
'55700',
'55710',
'55720',
'55730',
'55740',
'55750',
'55760',
'55770',
'55780',
'55790',
'55800',
'55810',
'55820',
'55830',
'55840',
'55850',
'55860',
'55870',
'55880',
'55890',
'55900',
'55901',
'55902',
'55903',
'55904',
'55905',
'55906',
'55907',
'55908',
'55909',
'55910',
'55911',
'55912',
'55913',
'55914',
'55915',
'55916',
'55917',
'55918',
'55919',
'55920',
'55921',
'55922',
'55923',
'55924',
'55925',
'55926',
'55927',
'55928',
'55929',
'55930',
'55931',
'55932',
'55933',
'55934',
'55935',
'55936',
'55937',
'55938',
'55939',
'55940',
'55950',
'55960',
'55970',
'55980',
'55990',
'56000',
'56010',
'56020',
'56030',
'56040',
'56050',
'56060',
'56070',
'56080',
'56090',
'56100',
'56110',
'56120',
'56130',
'56140',
'56150',
'56160',
'56170',
'56180',
'56190',
'56200',
'56210',
'56220',
'56230',
'56240',
'56250',
'56260',
'56270',
'56280',
'56290',
'56300',
'56310',
'56320',
'56330',
'56340',
'56350',
'56360',
'56370',
'56380',
'56390',
'56400',
'56410',
'56420',
'56430',
'56440',
'56450',
'56460',
'56470',
'56480',
'56490',
'56500',
'56510',
'56520',
'56530',
'56540',
'56550',
'56560',
'56570',
'56580',
'56590',
'56600',
'56610',
'56620',
'56630',
'56640',
'56650',
'56660',
'56670',
'56680',
'56690',
'56700',
'56710',
'56720',
'56730',
'56740',
'56750',
'56760',
'56770',
'56780',
'56790',
'56800',
'56810',
'56820',
'56830',
'56840',
'56850',
'56860',
'56870',
'56880',
'56890',
'56900',
'56910',
'56920',
'56930',
'56940',
'56950',
'56960',
'56970',
'56980',
'56990',
'57000',
'57010',
'57020',
'57030',
'57040',
'57050',
'57060',
'57070',
'57080',
'57090',
'57100',
'57110',
'57120',
'57130',
'57140',
'57150',
'57160',
'57170',
'57180',
'57190',
'57200',
'57210',
'57220',
'57230',
'57240',
'57250',
'57260',
'57270',
'57280',
'57290',
'57300',
'57310',
'57320',
'57330',
'57340',
'57350',
'57360',
'57370',
'57380',
'57390',
'57400',
'57410',
'57420',
'57430',
'57440',
'57450',
'57460',
'57470',
'57480',
'57490',
'57500',
'57510',
'57520',
'57530',
'57540',
'57550',
'57560',
'57570',
'57580',
'57590',
'57600',
'57610',
'57620',
'57630',
'57640',
'57650',
'57660',
'57670',
'57680',
'57690',
'57700',
'57710',
'57720',
'57730',
'57740',
'57750',
'57760',
'57770',
'57780',
'57790',
'57800',
'57810',
'57820',
'57830',
'57840',
'57850',
'57860',
'57870',
'57880',
'57890',
'57900',
'57910',
'57920',
'57930',
'57940',
'57950',
'57960',
'57970',
'57980',
'57990',
'58000',
'58010',
'58020',
'58030',
'58040',
'58050',
'58060',
'58070',
'58080',
'58090',
'58100',
'58110',
'58120',
'58130',
'58140',
'58150',
'58160',
'58170',
'58180',
'58190',
'58200',
'58210',
'58220',
'58230',
'58240',
'58250',
'58260',
'58270',
'58280',
'58290',
'58300',
'58310',
'58320',
'58330',
'58340',
'58350',
'58360',
'58370',
'58380',
'58390',
'58400',
'58410',
'58420',
'58430',
'58440',
'58450',
'58460',
'58470',
'58480',
'58490',
'58500',
'58510',
'58520',
'58530',
'58540',
'58550',
'58560',
'58570',
'58580',
'58590',
'58600',
'58610',
'58620',
'58630',
'58640',
'58650',
'58660',
'58670',
'58680',
'58690',
'58700',
'58710',
'58720',
'58730',
'58740',
'58750',
'58760',
'58770',
'58780',
'58790',
'58800',
'58810',
'58820',
'58830',
'58840',
'58850',
'58860',
'58870',
'58880',
'58890',
'58900',
'58910',
'58920',
'58930',
'58940',
'58950',
'58960',
'58970',
'58980',
'58990',
'59000',
'59010',
'59020',
'59030',
'59040',
'59050',
'59060',
'59070',
'59080',
'59090',
'59100',
'59110',
'59120',
'59130',
'59140',
'59150',
'59160',
'59170',
'59180',
'59190',
'59200',
'59210',
'59220',
'59230',
'59240',
'59250',
'59260',
'59270',
'59280',
'59290',
'59300',
'59310',
'59320',
'59330',
'59340',
'59350',
'59360',
'59370',
'59380',
'59390',
'59400',
'59410',
'59420',
'59430',
'59440',
'59450',
'59460',
'59470',
'59480',
'59490',
'59500',
'59510',
'59520',
'59530',
'59540',
'59550',
'59560',
'59570',
'59580',
'59590',
'59600',
'59610',
'59620',
'59630',
'59640',
'59650',
'59660',
'59670',
'59680',
'59690',
'59700',
'59710',
'59720',
'59730',
'59740',
'59750',
'59760',
'59770',
'59780',
'59790',
'59800',
'59810',
'59820',
'59830',
'59840',
'59850',
'59860',
'59870',
'59880',
'59890',
'59900',
'59910',
'59920',
'59930',
'59940',
'59950',
'59960',
'59970',
'59980',
'59990',
'60000',
'60100',
'60200',
'60300',
'60400',
'60500',
'60600',
'60700',
'60800',
'60900',
'61000',
'61100',
'61200',
'61300',
'61400',
'61500',
'61600',
'61700',
'61800',
'61900',
'68000',
'68010',
'68020',
'68030',
'68040',
'68050',
'68060',
'68070',
'68080',
'68090',
'68100',
'68110',
'68120',
'68130',
'68140',
'68150',
'68160',
'68170',
'68180',
'68190',
'68200',
'68210',
'68220',
'68230',
'68240',
'68250',
'68260',
'68270',
'68280',
'68290',
'68300',
'68310',
'68320',
'68330',
'68340',
'68350',
'68360',
'68370',
'68380',
'68390',
'68400',
'68410',
'68420',
'68430',
'68440',
'68450',
'68460',
'68470',
'68480',
'68490',
'68500',
'68510',
'68520',
'68530',
'68540',
'68550',
'68560',
'68570',
'68580',
'68590',
'68600',
'68610',
'68620',
'68630',
'68640',
'68650',
'68660',
'68670',
'68680',
'68690',
'68700',
'68710',
'68720',
'68730',
'68740',
'68750',
'68760',
'68770',
'68780',
'68790',
'68800',
'68810',
'68820',
'68830',
'68840',
'68850',
'68860',
'68870',
'68880',
'68890',
'68900',
'68910',
'68920',
'68930',
'68940',
'68950',
'68960',
'68970',
'68980',
'68990']
window.validPostalCodes = validPostalCodes;